// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-page-base-info__info-blocks[data-v-52f9afe8]{grid-column-gap:10px;grid-row-gap:20px;-moz-column-gap:10px;column-gap:10px;display:grid;grid-template-columns:repeat(2,auto);row-gap:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
